import React from 'react';
import { Button, Icon, useDisclosure } from '@wegroup/design-system';
import { useTranslation } from 'react-i18next';
import useTracking from '../../../../../../../../common/src/hooks/tracking/useTracking';
import AddInsuranceModal from '../../shared/modal/AddInsuranceModal';
import { Option } from '../../../../../../../../design-system/src/content/components/SearchPickerInput';
import {
  InsurancePolicy,
  InsurancePolicyPackage,
} from '../../../../../../types/AdvisoryReport';

interface Props {
  packageData: InsurancePolicyPackage;
  controlled?: boolean;
  customRiskObjects?: Option[];
  onAdd?: (insurancePolicy: InsurancePolicy) => void;
  hideAIBanner?: boolean;
}

const AddPackageInsurancePolicyButton: React.FC<Props> = ({
  customRiskObjects = [],
  controlled,
  packageData,
  onAdd,
  hideAIBanner,
}) => {
  const { t } = useTranslation();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { trackEvent } = useTracking();
  const handleAdd = () => {
    trackEvent(
      `Add insurance policy to package in advisory report creation flow`,
    );
    onOpen();
  };

  return (
    <>
      <AddInsuranceModal
        type="CURRENT-INSURANCE"
        mode="ADD"
        isOpen={isOpen}
        controlled={controlled}
        onSubmit={onAdd}
        onClose={onClose}
        customRiskObjects={customRiskObjects}
        hideAIBanner={hideAIBanner}
        initialData={{
          policy_package_id:
            packageData.id || 'ae9227e1-369a-482d-9906-58ad7862c684',
          insurance_company: packageData.insurance_company,
          due_date: packageData.due_date,
        }}
      />
      <Button
        onClick={handleAdd}
        leftIcon={<Icon name="GeneralActionsAdd" />}
        variant="dashed"
        borderColor="gray.200"
        width="100%"
        size="sm"
      >
        {t('ADVISORY-REPORTS_CREATION-FLOW_PACKAGES_ADD-INSURANCE')}
      </Button>
    </>
  );
};

export default AddPackageInsurancePolicyButton;
